import { Directive, OnChanges, SimpleChanges, input, output } from '@angular/core';

import { VariationAttribute } from 'ish-core/models/product-variation/variation-attribute.model';
import { VariationProduct } from 'ish-core/models/product/product.model';

@Directive({ selector: '[customCreateFilter]' })
export class CreateFilterDirective implements OnChanges {
  readonly prod = input<VariationProduct[]>([]);
  readonly groupedProducts = output<{
    [key: string]: string[];
  }>();

  ngOnChanges(changes: SimpleChanges): void {
    const prod = this.prod();
    if (changes.prod && prod) {
      this.createFilters(prod);
    }
  }

  createFilters(prod: VariationProduct[]) {
    const allVariations: VariationAttribute[] = prod.flatMap(product => product.variableVariationAttributes);
    const transformedObject = allVariations.reduce((acc: any, obj: VariationAttribute) => {
      const trimmedValue = obj.value?.toString()?.trim(); // Trim the value to remove any leading or trailing spaces   //toString() ADDED DURING MIGRATION TO BE REMOVED WHILE VALIDATING
      acc[obj.name] = acc[obj.name] || new Set();
      acc[obj.name].add(trimmedValue);
      return acc;
    }, {});

    const grouped: { [key: string]: string[] } = {};
    Object.keys(transformedObject).forEach(key => {
      grouped[key] = Array.from(transformedObject[key]);
    });

    this.groupedProducts.emit(grouped);
  }
}
